import { useEffect, useRef } from "react";
import { ArrowRight, CircleHelp, Lightbulb } from "lucide-react";
import { Aviso, BTN_PRIMARIO, BTN_TEXTO, TextoAjuda } from "@/core/components/ajuda/ajudaUi";

interface ConteudoApresentacaoProps {
  totalLicoes: number;
  onComecar: () => void;
  onPular: () => void;
  /** `h1` na página própria; `h2` quando aparece por cima de outra tela (que já tem o seu `h1`). */
  nivelTitulo?: "h1" | "h2";
  idTitulo?: string;
}

/**
 * Boas-vindas da Ajuda do Elos. Usada na página `/ajuda/apresentacao` e na tela de boas-vindas que
 * se sobrepõe ao Início no primeiro acesso. Ninguém é obrigado a passar por aqui: "Pular por agora"
 * sempre sai, e a Ajuda continua no menu da conta.
 */
export function ConteudoApresentacao({
  totalLicoes,
  onComecar,
  onPular,
  nivelTitulo = "h1",
  idTitulo,
}: ConteudoApresentacaoProps) {
  const tituloRef = useRef<HTMLHeadingElement>(null);
  const Titulo = nivelTitulo;

  useEffect(() => {
    tituloRef.current?.focus();
  }, []);

  return (
    <div className="text-center">
      <span className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-primary/10 text-primary">
        <CircleHelp size={32} aria-hidden="true" />
      </span>
      <Titulo
        ref={tituloRef}
        id={idTitulo}
        tabIndex={-1}
        className="mb-3 text-2xl font-black tracking-tight text-text outline-none sm:text-3xl"
      >
        Bem-vindo ao Elos
      </Titulo>
      <TextoAjuda texto="Aqui você acompanha a vida da sua igreja, num só lugar." />
      <TextoAjuda
        texto={`Vamos conhecer o Elos em **${totalLicoes} lições curtas**.`}
        className="mt-3"
      />

      <div className="mt-8 flex flex-col gap-3 sm:items-center">
        <button type="button" onClick={onComecar} className={BTN_PRIMARIO}>
          Começar
          <ArrowRight size={20} aria-hidden="true" />
        </button>
        <button type="button" onClick={onPular} className={BTN_TEXTO}>
          Pular por agora
        </button>
      </div>

      <div className="text-left">
        <Aviso icone={<Lightbulb size={20} aria-hidden="true" />}>
          Você pode voltar quando quiser. Abra o <strong>menu</strong>, no canto de cima à direita,
          e toque em <strong>Ajuda do Elos</strong>.
        </Aviso>
      </div>
    </div>
  );
}
